<template>
    <modal
        :saveAction="save"
        :title="title"
        :id="id"
        :deleteAction="data._id ? data.can_delete ? deleteAction : false : false"
        :actionButtons="!hideForm"
        size="lg"
        :closeButton="hideForm"
        @shown="shown() "
    >
        <div class="row align-items-center mb-2">
            <div class="col-2">
                <b-form-group :label="$t('Code')">
                    <b-form-input v-model="icdModel.code" :placeholder="$t('Ex.: A001')"></b-form-input>
                </b-form-group>
            </div>
            <div class="col-1" v-if="false">
                <b-form-group :label="$t('Rank')">
                    <b-form-input v-model="icdModel.rank" placeholder="0-10"></b-form-input>
                </b-form-group>
            </div>
            <div class="col-8">
                <b-form-group :label="$t('Label')">
                    <b-form-input v-model="icdModel.label" :placeholder="$t('Ex.: Pain while eating')"></b-form-input>
                </b-form-group>
            </div>

            <div class="col-2">
                <b-form-group :label="$t('Language')">
                    <b-form-select v-model="icdModel.language" :options="languages"></b-form-select>
                </b-form-group>
            </div>
        </div>
        <div class="row">
            <div class="col-6" v-for="(item, index) in icdModel.icd" :key="index">
                <div class="card mb-1">
                    <div class="card-body p-3">
                        <div class="row align-items-center">
                            <div class="col-auto">
                                <strong>{{item.code}}</strong>
                            </div>
                            <div class="col">{{item.label}}</div>
                            <div class="col-auto">
                                <button class="btn btn-white btn-sm mr-1" @click="removeDiangosis(index)">
                                    <i class="fe fe-x"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt -2">
            <div class="col">
                <button class="btn btn-white" @click="openModal({ id: 'ICDModal' });">
                    <i class="fe fe-activity"></i>
                    {{$t('Select diagnosis')}}
                </button>
            </div>
        </div>
        <i-c-d-modal id="ICDModal" :useAction="use"></i-c-d-modal>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import ICDModal from '@/components/ICD10/ICDModal.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { modalMixins } from '@/mixins/modal.js'


export default {
    name: 'cdb-modal',
    props: ['id', 'saveAction', 'data'],
    mixins: [modalMixins],
    components: {
        Modal,
        ICDModal
    },
    data() {
        return {
            complaints: [{}],
            loading: false,
            hideForm: false,
            languages: [
                { text: 'English', value: 'english' },
                { text: 'Russian', value: 'russian' },
            ],
            icdModel: {
                language: 'russian'
            },
            title: 'CDB ',
        }
    },
    computed: {

    },
    mounted() {

        this.$root.$on('bv::hide::modal', (modal) => {
            this.hideForm = false;
        })
        return this.find({ query: {} }).data;

    },

    methods: {
        ...mapActions('cdb', ['find', 'create', 'patch', 'remove']),
        deleteAction() {
            this.remove(this.data._id).then(result => {
                // this.$router.go(-1);
                this.$toasted.global.success({
                    message: this.$t('Item has been removed')
                });
            });
        },
        save() {
            let promise, successMessage;
            if (this.icdModel._id) {
                promise = this.patch([this.icdModel._id, this.icdModel]);
                successMessage = this.$t('Complaint has been updated');
            } else {
                promise = this.create(this.icdModel);
                successMessage = this.$t('Complaint has been created');
            }


            promise.then(result => {
                this.$root.$emit('bv::hide::modal', this.id);
                this.$toasted.global.success({
                    message: successMessage
                });
            });
        },

        shown() {
            /* Switch back to the first tab */
            this.icdModel = this.data;
            if (!this.data.icd) {
                this.$set(this.icdModel, 'icd', []);
            }

        },
        validation(field) {
            if (this.errors && this.errors[field])
                return false
            else
                return null
        },
        removeDiangosis(index) {
            this.icdModel.icd.splice(index, 1);
        },
        use(item) {
            this.icdModel.icd.push(item);
        },

    },

}
</script>
<style>
.pre-formatted {
  white-space: pre;
}
</style>
